<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
    :hot-key-create-path="`/product-location/create/${this.baseView.id}`"
    :hot-key-grid-tab-index="4"
    :hot-key-create-route-id="model.ProductCode"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Product"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.ProductCode"
        :secondaryLabel="model.ProductDescription1"
        recordType="Product"
        v-if="model.ProductCode"
      />
    </template>
    <div class="css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  ref="productLocationGrid"
                  :columns="columns"
                  :height="gridHeight - 20"
                  @cell-click="onCellClick"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  @content-ready="addGridNoResults($event)"
                  v-if="model.ProductCode"
                  :selection="{ mode: 'single' }"
                  @exporting="
                    onGridToExcelExporting(
                      $event,
                      `Product - ${baseView.id} - Locations`,
                      columns
                    )
                  "
                >
                  <DxPaging :page-size="50" :enabled="false" />
                  <DxPager
                    :showInfo="true"
                    :showPageSizeSelector="false"
                    :infoText="'({2} items)'"
                    :visible="false"
                  />

                  <DxScrolling
                    :mode="'virtual'"
                    :row-rendering-mode="'virtual'"
                    :preloadEnabled="true"
                  />
                  <DxExport :enabled="true" />
                  <template #default-cell-template="{ data }">
                    <DxCheckBox
                      :value="data.data.IsDefault == 'Y'"
                      :read-only="data.data.IsDefault == 'Y'"
                      @valueChanged="onIsDefaultChange($event, data.data)"
                    />
                  </template>

                  <template #branch-cell-template="{ data }">
                    <GcDescriptionCodeCellTemplate
                      :description="data.data.BranchDescription"
                      :code="data.data.BranchCode"
                    />
                  </template>

                  <template #location-cell-template="{ data }">
                    <GcDescriptionCodeCellTemplate
                      :description="data.data.BinLocationLocation"
                      :code="data.data.BinLocationCode"
                    />
                  </template>
                </dx-data-grid>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                  :initial-filter="initialFilter"
                  v-if="model.ProductCode"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem
              widget="dxForm"
              location="after"
              :options="{
                formData: model,
                items: toolbarActiveItems,
                validationGroup: 'toolbarForm-2',
                labelLocation: 'left',
                customizeItem: customizeItem,
              }"
              locate-in-menu="auto"
            ></DxItem>
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <!-- <DxItem
              :options="toolbar.delete"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            /> -->

            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form v-if="loadingCompleted">
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :ref="'product-location'"
                :items="items"
              >
                <template #branch="{ data }">
                  <div class="custom-auto-complete">
                    <span class="auto-complete-primary">{{
                      data.Description
                    }}</span>
                    <span class="auto-complete-secondary">{{ data.Code }}</span>
                  </div>
                </template>
                <template #binLocation="{ data }">
                  <div class="custom-auto-complete">
                    <span class="auto-complete-primary">{{
                      data.Location
                    }}</span>
                    <span class="auto-complete-secondary">{{ data.Code }}</span>
                  </div>
                </template>
              </DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { BranchService } from "../../_services/api/sales/branch.service";

import { BinLocationService } from "../../_services/api/settings/products/bin-location.service";
import BaseViewMixin from "../../v1/_mixins/base.view";
import validationEngine from "devextreme/ui/validation_engine";
import { ProductService } from "../../_services/api/products/product.service";
import { ProductLocationService } from "../../_services/api/products/product-location.service";
import {
  ProductTabs,
  ProductTabsVisibility,
} from "../../_models/tabdata/products/products-tabs";

export default {
  mixins: [BaseViewMixin],
  created() {
    this.selectedIndex = 4;
  },
  mounted() {
    if (this.loadingCompleted)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  updated() {
    if (this.loadingCompleted)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",
          onClick: this.close,
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/product-location/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          ref: "saveButton",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveProductLocation(e);
          },
        },
        delete: {
          icon: "trash",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickDelete();
            this.deleteProductBin(e);
          },
        },
        audit: {
          icon: "clock",

          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      advanceFilterModel: {
        BranchCode: "",
        BinLocationCode: "",
      },
      model: {
        ProductCode: "",
        ProductDescription1: "",
        BranchCode: "",
        BinLocationCode: "",
        BinLocationLocation: "",
        IsDefault: true,
        IsDefaultReadOnly: false,
        RecordId: "00000000-0000-0000-0000-000000000000",
        AllBranches: true,
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
      },
    };
  },
  computed: {
    toolbarActiveItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "AllBranches",
              gcType: "Boolean",
              gcLabel: "Update All Branches",
            },
          ]),
        },
      ];
    },
    initialFilter() {
      return [["ProductCode", "=", this.model.ProductCode]];
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "BranchCode",
              gcLabel: "Branch",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig("api/Branch", {
                  select: ["Code", "Description"],
                  sort: [{ selector: "Code", asc: true }],
                  top: 5,
                  filter: ["Inactive", "=", "N"],
                  key: "Code",
                }),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                itemTemplate: "item-template",
                searchEnabled: true,
              },
            },
            {
              dataField: "BinLocationCode",
              gcLabel: "Location",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig("api/BinLocation", {
                  select: ["Code", "Location"],
                  sort: [{ selector: "Code", asc: true }],
                  top: 5,
                  filter: ["Inactive", "=", "N"],
                  key: "Code",
                }),
                valueExpr: "Code",
                displayExpr: "Location",
                searchExpr: ["Code", "Location"],
                searchMode: "contains",
                itemTemplate: "location-template",
                searchEnabled: true,
              },
            },
          ]),
        },
      ];
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Branch",
          dataField: "BranchDescription",
          cellTemplate: "branch-cell-template",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          gcExport: ["BranchCode", "BranchDescription"],
        },
        {
          gcLabel: "Location",
          dataField: "BinLocationLocation",
          cellTemplate: "location-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
          gcExport: ["BinLocationCode", "BinLocationLocation"],
        },
        {
          gcLabel: "Default",
          dataField: "IsDefault",
          gcType: "String",
          width: 100,
          cellTemplate: "default-cell-template",
        },
        {
          gcLabel: "Branch Code",
          dataField: "BranchCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Branch Description",
          dataField: "BranchDescription",
          width: 220,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Location Code",
          dataField: "BinLocationCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Location Description",
          dataField: "BinLocationLocation",
          width: 220,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
      ]);
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "BranchCode",
              gcLabel: "Branch",
              gcType: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: BranchService.dataSourceConfig("api/Branch", {
                  select: ["Description", "Code"],
                  filter: ["Inactive", "=", "N"],
                  sort: [{ selector: "Description", asc: true }],
                }),
                valueExpr: "Code",
                searchExpr: ["Description"],
                searchMode: "contains",
                showClearButton: true,
                itemTemplate: "branch",
                searchEnabled: true,
                displayExpr: "Description",
              },
              validationRules: [
                {
                  type: "required",
                  message: "Branch is required",
                },
                {
                  type: "async",
                  validationCallback: this.branchCodeExistsRuleCallback,
                  message: "Branch does not exist",
                },
              ],
            },

            {
              dataField: "BinLocationCode",
              gcLabel: "Bin",
              gcType: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: BinLocationService.dataSourceConfig(
                  "api/BinLocation",
                  {
                    select: ["Location", "Code"],
                    filter: ["Inactive", "=", "N"],
                    sort: [{ selector: "Location", asc: true }],
                  }
                ),
                valueExpr: "Code",
                searchExpr: ["Location"],
                searchMode: "contains",
                showClearButton: true,
                itemTemplate: "binLocation",
                searchEnabled: true,
                displayExpr: "Location",
              },
              validationRules: [
                {
                  type: "required",
                  message: "Bin Location is required",
                },
                {
                  type: "async",
                  validationCallback: this.binLocationCodeExistsRuleCallback,
                  message: "Bin Location does not exist",
                },
              ],
            },

            // {
            //   itemType: "group",
            //   caption: "",
            //   items: [
            //     {
            //       dataField: "AllBranches",
            //       label: { text: "All Branches" },
            //       editorType: "dxSwitch",
            //     },
            //   ],
            // },
            {
              dataField: "IsDefault",
              disabled: this.model.IsDefaultReadOnly,
              gcLabel: "Default",
              gcType: "Boolean",
            },
          ]),
        },
      ];

      return formFields;
    },
    dataSourceConfig() {
      return ProductLocationService.dataSourceConfig(
        "api/ProductLocationList",
        {
          select: [
            "BranchDescription,BranchCode,BinLocationLocation,BinLocationCode,IsDefault,ProductCode,RecordId",
          ],
          // sort: [{ selector: "ProductCode", desc: false }],
          filter: [["ProductCode", "=", this.model.ProductCode]],
        }
      );
    },
    tabs() {
      if (this.loadingCompleted)
        return ProductTabs(
          this.model.ProductCode ? this.model.ProductCode : this.baseView.id
        );
      return [];
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    showRightContainer() {
      setTimeout(() => {
        let grid = this.$refs["productLocationGrid"].instance;
        grid.updateDimensions();
      }, 10);
    },
  },
  methods: {
    onIsDefaultChange(e, data) {
      var payload = {
        ProductCode: data.ProductCode,
        BinLocationCode: data.BinLocationCode,
        BranchCode: data.BranchCode,
        RecordId: data.RecordId,
        IsDefault: e.value ? "Y" : "N",
        AllBranches: "N",
      };

      if (e.value) {
        this.showLoading(true);
        this.checkBranchLocationDefault(e, data, () => {
          this.updateProductLocationDefault("edit", payload);
        });
      } else {
        this.updateProductLocationDefault("edit", payload);
      }
    },

    async checkBranchLocationDefault(fieldData, data, callBack) {
      await ProductLocationService.getDefaultBinLocation(
        data.BranchCode,
        data.ProductCode
      )
        .then(async (res) => {
          if (res.data.value.length > 0) {
            this.showLoading(false);
            let confirmDefault = await this.$confirm(
              "This branch already has another location configured as the Default Location. Do you want to change it?",
              "Validation"
            );
            if (confirmDefault) {
              this.showLoading(true);
              callBack();
            } else {
              fieldData.value = false;
              fieldData.component.beginUpdate();
              fieldData.component.option("value", false);
              fieldData.component.endUpdate();
              this.showLoading(false);
            }
          } else {
            callBack();
          }
        })
        .catch((err) => {
          if (err) this.showLoading(false);
          this.displayServerError(err, "Server Error");
        });
    },
    async close() {
      if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["productLocationGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.ProductCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-location/review/${this.baseView.id}`,
          });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["productLocationGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.ProductCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router
          .push({
            path: `/product-location/review/${this.baseView.id}`,
          })
          .then((res) => {
            if (res) {
              grid.beginUpdate();
              grid.updateDimensions();
              grid.endUpdate();
            }
          });
      }
    },
    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/product",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      exportButton.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: () => {
              this.$logger.trackEventButtonClickAddNew();
              this.model.BranchCode = "";
              this.model.BinLocationCode = "";
              this.model.BinLocationLocation = "";
              this.model.IsDefault = true;
              this.model.IsDefaultReadOnly = false;
              this.model.BranchCode = "";
              this.model.AllBranches = true;
              this.model.RecordId = "00000000-0000-0000-0000-000000000000";
              this.model.DateChanged = "";
              this.model.DateCreated = "";
              this.model.ChangedBy = "";
              this.model.CreatedBy = "";
              this.baseView.id = this.model.ProductCode;

              this.$router.push({
                path: `/product-location/create/${this.baseView.id}`,
              });
            },
          },
        },
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
        // exportButton
      );
    },
    async handleLocalRouteChange() {
      let that = this;
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        if (this.baseView.id) this.showLoading(true);
        this.model.RecordId = this.baseView.id;
        this.getRecord().then((response) => {
          if (response.data.value.length > 0) {
            that.model.ProductCode = response.data.value[0].ProductCode;
            that.model.ProductDescription1 =
              response.data.value[0].Product.Description1;
            that.model.BinLocationCode = response.data.value[0].BinLocationCode;
            that.model.IsDefault =
              response.data.value[0].IsDefault == "Y" ? true : false;
            that.model.IsDefaultReadOnly = that.model.IsDefault;
            that.model.BranchCode = response.data.value[0].BranchCode;
            that.model.RecordId = response.data.value[0].RecordId;

            that.model.DateChanged = response.data.value[0].DateChanged;
            that.model.DateCreated = response.data.value[0].DateCreated;
            that.model.ChangedBy = response.data.value[0].ChangedBy;
            that.model.CreatedBy = response.data.value[0].CreatedBy;
            ProductTabsVisibility({
              text: "Kit Components",
              value: response.data.value[0].Product.IsKit == "Y" ? true : false,
            });

            // that.refreshView();
            // This fixes up case sensitity issues with remote data in SelectBox
            if (that.$refs["product-location"])
              that.validateFormConfig(that.$refs["product-location"].instance);
          }
          that.loadingCompleted = true;
          that.showLoading(false);
        });
      } else {
        if (!that.model.ProductCode) {
          await ProductService.getByCode(that.baseView.id).then((response2) => {
            if (response2.data.value.length > 0) {
              that.model.ProductCode = response2.data.value[0].Code;
              that.model.ProductDescription1 =
                response2.data.value[0].Description1;
              // that.refreshView();
              ProductTabsVisibility({
                text: "Kit Components",
                value: response2.data.value[0].IsKit == "Y" ? true : false,
              });
            }
            this.loadingCompleted = true;
          });
        } else {
          // if (this.showRightContainer)
          this.loadingCompleted = true;
        }
        that.showLoading(false);
      }
    },
    binLocationCodeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        BinLocationService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.BinLocationCode = response.data.value[0].Code;
            this.model.BinLocationLocation = response.data.value[0].Location;
            resolve(true);
          } else {
            this.model.BinLocationCode = "";
            resolve(false);
          }
        });
      });
    },

    branchCodeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        BranchService.getByCode(params.value).then((response) => {
          if (
            response.data.value.length > 0 &&
            response.data.value[0].Inactive == "N"
          ) {
            this.model.BranchCode = response.data.value[0].Code;
            resolve(true);
          } else {
            this.model.BranchCode = "";
            resolve(false);
          }
        });
      });
    },

    async getRecord() {
      return ProductLocationService.getByRecordId(this.baseView.id);
    },
    onCellClick(e) {
      if (e.rowType == "data" && e.data) {
        if (e.column.dataField != "IsDefault") {
          this.baseView.id = e.data.RecordId;
          this.$router
            .push({
              path: `/product-location/review/${e.data.RecordId}`,
            })
            .then((res) => {
              if (res) {
                let grid = this.$refs["productLocationGrid"].instance;
                grid.beginUpdate();
                grid.updateDimensions();
                grid.endUpdate();
              }
            });
        }
      }
    },
    async deleteProductBin() {
      let that = this;

      let confirmLeaving = await this.$confirm(
        `Are you sure you want to delete this location?`,
        "Delete Location"
      );

      if (confirmLeaving) {
        this.showLoading(true);
        await ProductLocationService.delete({
          RecordId: this.model.RecordId,
        })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            that.showLoading(false);
            that.close();
            let grid = this.$refs["productLocationGrid"].instance;
            grid.refresh();
          })
          .catch((error) => {
            this.displayServerError(error, "Product Location delete failed");
          });
      }
    },
    async saveProductLocation(e) {
      const result = await e.validationGroup.validate();
      // eslint-disable-next-line no-console
      // this.$logger.debug("Model", this.model);
      if (!result.isValid) {
        this.displayValidationSummary();
        return;
      }
      this.showLoading(true);
      await ProductLocationService.save(this.baseView.mode, {
        ProductCode: this.model.ProductCode,
        BinLocationCode: this.model.BinLocationCode,
        BranchCode: this.model.BranchCode,
        RecordId: this.model.RecordId,
        IsDefault: this.model.IsDefault ? "Y" : "N",
        AllBranches: this.model.AllBranches ? "Y" : "N",
      })
        .then((res) => {
          if (this.baseView.mode == "create") {
            this.model.RecordId = res.data.RecordId;
          }

          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveProductLocation", res);
          this.$notify(
            `Product Location ${this.model.BinLocationLocation} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/product-location/review/${this.model.RecordId}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Product Location save failed");
        });
    },

    async updateProductLocationDefault(mode, paload) {
      await ProductLocationService.save(mode, paload)
        .then((res) => {
          if (res) this.showLoading(false);
          let grid = this.$refs["productLocationGrid"].instance;
          grid.refresh(true);
        })
        .catch((error) => {
          if (error) this.showLoading(false);
          this.displayServerError(error, "Product Location save failed");
        });
    },
  },
};
</script>
